import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import ButtonLink from '../../../components/ButtonLink';

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(1, 0),
    fontSize: theme.typography.pxToRem(12)
  }
}));

const TrackingNumber = ({ rxForm, onClickTrackingNumber }) => {
  const classes = useStyles();

  const trackingNumber = useMemo(() => {
    if (!rxForm) {
      return null;
    }

    if (rxForm.tracking_number) {
      return (
        <ButtonLink onClick={() => onClickTrackingNumber(rxForm.tracking_number)}>
          {rxForm.tracking_number}
        </ButtonLink>
      );
    }

    return 'Pending';
  }, [rxForm, onClickTrackingNumber]);

  if (!rxForm) {
    return null;
  }

  return (
    <div className={classes.container}>
      <strong>Tracking # </strong> {trackingNumber}
    </div>
  );
};

TrackingNumber.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  rxForm: PropTypes.object,
  onClickTrackingNumber: PropTypes.func.isRequired
};

TrackingNumber.defaultProps = {
  rxForm: null
};

export default TrackingNumber;
